'use client';

import { useEffect } from 'react';
import { decodeDrep } from '@src/utils/validationUtils';
import { hexToBech32 } from '@src/utils/stringUtils';
import { useParams } from 'next/navigation';
import { toast } from 'react-toastify';
import ProfileWrapper from '@src/container/profileWrapper';
import { readSearchParam } from '@src/utils/searchParamsUtils';

function DRepPage({ seoVotes, ...dRepDetails }: any) {
  const params = useParams();

  useEffect(() => {
    const dRepId = params['dRepId'];
    try {
      if (dRepId) {
        const decodedDRep = decodeDrep(dRepId as string);
        const CIP129FormatDRep = decodedDRep.isScript
          ? hexToBech32('23' + decodedDRep.credential)
          : hexToBech32('22' + decodedDRep.credential);
        if (CIP129FormatDRep != dRepId) {
          toast.success(
            'You are using legacy DRep Format. Redirecting you now!'
          );
          window.history.replaceState(
            {},
            '',
            `${CIP129FormatDRep}?tab=${readSearchParam('tab') || 'info'}`
          );
        }
      }
    } catch (e) {
      console.log('Error in decoding DRep', e);
    }
  }, []);
  return (
    <ProfileWrapper
      dRepDetails={dRepDetails}
      fromDRepId={true}
      seoVotes={seoVotes}
    />
  );
}

export default DRepPage;
